module.exports = __webpack_public_path__ + "static/32@3x.e867046a.svg";